import { makeAutoObservable } from "mobx";
import type { Credential } from "@smartsuite/automation-engine-api";

export class CredentialStore {
  list: Credential[] = [];
  pageSize: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  setList(credentialList: Credential[]): void {
    this.list = credentialList;
  }

  appendItemIfNew(credential: Credential): void {
    this.list = this.list.some(
      (c) => c.credentialId === credential.credentialId,
    )
      ? this.list
      : [...this.list, credential];
  }

  removeItem(id: string): void {
    this.list = this.list.filter((c) => c.credentialId !== id);
  }
}
